import { z } from "zod";

import { BooleanAttributeSchema } from "./BooleanAttributeSchema";

export const ButtonActionSchema = z.object({
    openInNewTab: BooleanAttributeSchema.optional(),
    url: z.string().trim().optional(),
});
